import {useEffect} from 'react';
import {useMap, useMapEvents} from 'react-leaflet';
import {useDispatch} from 'react-redux';
import {actionCreator} from '../_modules';
import {Props} from './types';


const MapController: React.FC<Props> = (props: Props) => {
  const dispatch = useDispatch();

  const llMap = useMap();
  /* Methods
    llMap.panTo(coordinate) // move map center
  */

  useEffect(() => {
    llMap.closePopup();
  }, [props.store.activeLocation]);

  useEffect(() => {
    if (props.store.mapBounds === undefined) {
      return;
    }
    llMap.fitBounds([
      [
        props.store.mapBounds?.minLngLat[1],
        props.store.mapBounds?.minLngLat[0],
      ],
      [
        props.store.mapBounds?.maxLngLat[1],
        props.store.mapBounds?.maxLngLat[0],
      ],
    ]);
  }, [props.store.mapBounds]);

  useEffect(() => {
    llMap.fitBounds([
      [24.263122, 125.047986],
      [48.126956, 150.433439],
    ]);
  }, [props.state.initZoom]);

  useMapEvents({
    click(e: any) {
      props.store.searchType === 'distance' &&
          dispatch(actionCreator.pointOnMap({lnglat: [e.latlng.lng, e.latlng.lat]}));
      props.store.searchType === 'distance' &&
          dispatch(actionCreator.moveMapCenter({lnglat: [e.latlng.lng, e.latlng.lat]}));
    },
  });
  return null;
};


export default MapController;
